import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomModalComponent } from 'hig-ng-lib';
import { HukSelect } from 'huk-angular-bindings';
import { AppConfig } from '../../../../config/app-config';
import { REFINE_CLAIM_RESULTS_TITLE } from '../../../../treo.properties';
import { LoaderService } from '../../../core/services/loading.service';
import { SharedService } from '../../../core/services/shared.service';
import { OshaService } from '../../osha-reporting/osha.service';
import { ClaimsService } from '../claims.service';
import { DateTypeComponent } from '../dynamic-form-components/date-type/date-type.component';
import moment from 'moment';

@Component({
    selector: 'app-refine-results-modal',
    templateUrl: './refine-results-modal.component.html',
    standalone: false
})
export class RefineResultsModalComponent implements OnInit {
    @ViewChild('RefineTheseResultsModal', { static: true }) RefineTheseResultsModalRef: CustomModalComponent;
    @ViewChild('claimNumberSelectionTemplate', { static: true }) claimNumberSelectionTemplate;
    @ViewChild('insuredDriverNameSelectionTemplate', { static: true }) insuredDriverNameSelectionTemplate;
    @ViewChild('accidentDateSelectionTemplate', { static: true }) accidentDateSelectionTemplate;
    @ViewChild('totalPaidSelectionTemplate', { static: true }) totalPaidSelectionTemplate;
    @ViewChild('totalIncurredSelectionTemplate', { static: true }) totalIncurredSelectionTemplate;
    @ViewChild('cancelResultsBtnTemplate', { static: true }) cancelResultsBtnTemplate;
    @ViewChild('resetBtnTemplate', { static: true }) resetBtnTemplate;
    @ViewChild('refineResultsBtnTemplate', { static: true }) refineResultsBtnTemplate;
    @ViewChild('accidentDateValueTemplate', { static: true }) accidentDateValueTemplate;
    @ViewChild('claimStatusMultiselect') claimStatusMultiselect: HukSelect;
    @ViewChild('locationCodeMultiselect') locationCodeMultiselect: HukSelect;
    @ViewChild('DateTypeComponent') DateTypeComponent: DateTypeComponent;
    @Input() type = '';
    @Input() context: string; // 'claims' or 'osha'
    @Input() refineWithKey;
    @Input() showRefine: boolean = false;
    @Output() hideRefine = new EventEmitter();
    @Input() hideRefineFunction = () => { };
    @Input() columnList = undefined;
    @Output() refineButtonEmit = new EventEmitter<{
        onSuccessMessage: boolean;
        apiResponse: any;
        updatedColumnToSend: any;
    }>();
    refineTheseResultsTitle: any;
    RefineTheseResultsForm: UntypedFormGroup;
    RefindResultForm: UntypedFormGroup = new UntypedFormGroup({});
    onSuccessMessage: boolean = false;
    updatedColumnToSend: any;
    hideClaimFeild: boolean = false;

    claimStatus: any = ['Open', 'Closed'];
    locationCode: any = ['0000', '00023', '000239', '0003739', '00081'];
    columns: any;
    claimNumberData: any;
    apiResponse: any;
    apiDataRefine: any;
    claimStatusSelectedValue: any;
    locationCodeSelectedValue: any;
    valueOfRefineResults: any;
    hideTotalIncurred: boolean = true;
    hideTotalPaid: boolean = true;
    hideAccidentDate: boolean = true;
    fields: any;
    ClaimNumberValue = {
        value: '',
        type: 'input',
        showField: true,
        name: '',
        id: 'claim-lists-claim-number-value-ts',
        className: 'm-1',
        isTealiumAllowed: false,
        placeHolder: '',
        label: '',
        validations: [
            {
                name: 'required',
                message: 'Please enter a valid number'
            },
            {
                name: 'pattern',
                message: 'Not a valid number',
                pattern: '[a-zA-Z0-9]{3}\\s[a-zA-Z]{1,2}\\s[0-9]{5}'
            }
        ]
    };

    insuredDriverValue = {
        value: '',
        type: 'input',
        showField: true,
        name: 'insuredDriverValue',
        id: 'claim-lists-insured-driver-value-ts',
        className: 'm-1',
        isTealiumAllowed: false,
        placeHolder: '',
        label: ''
    };

    totalPaidValue = {
        type: 'input',
        subType: 'currency',
        name: 'totalPaidValue',
        id: 'claim-lists-total-paid-value-ts',
        className: 'm-1',
        inputClass: '',
        value: '',
        disabled: false,
        showField: true,
        isTealiumAllowed: true,
        validations: [
            {
                name: 'required',
                message: 'Please enter a valid number'
            },
            {
                name: 'pattern',
                message: 'Not a valid number',
                pattern: '[a-zA-Z0-9]{3}\\s[a-zA-Z]{1,2}\\s[0-9]{5}'
            }
        ]
    };

    totalPaidValueSecond = {
        type: 'input',
        subType: 'currency',
        name: 'totalPaidValueSecond',
        id: 'claim-lists-total-paid-value-ts',
        className: 'm-1',
        inputClass: '',
        value: '',
        disabled: false,
        showField: true,
        isTealiumAllowed: true,
        validations: [
            {
                name: 'required',
                message: 'Please enter a valid number'
            },
            {
                name: 'pattern',
                message: 'Not a valid number',
                pattern: '[a-zA-Z0-9]{3}\\s[a-zA-Z]{1,2}\\s[0-9]{5}'
            }
        ]
    };

    totalIncurredValue = {
        type: 'input',
        subType: 'currency',
        name: 'totalIncurredValue',
        id: 'claim-lists-total-incurred-value-ts',
        className: 'm-1',
        inputClass: '',
        value: '',
        disabled: false,
        showField: true,
        isTealiumAllowed: true,
        validations: [
            {
                name: 'required',
                message: 'Please enter a valid number'
            },
            {
                name: 'pattern',
                message: 'Not a valid number',
                pattern: '[a-zA-Z0-9]{3}\\s[a-zA-Z]{1,2}\\s[0-9]{5}'
            }
        ]
    };

    totalIncurredValueSecond = {
        type: 'input',
        subType: 'currency',
        name: 'totalIncurredValueSecond',
        id: 'claim-lists-total-incurred-value-ts',
        className: 'm-1',
        inputClass: '',
        value: '',
        disabled: false,
        showField: true,
        isTealiumAllowed: true,
        validations: [
            {
                name: 'required',
                message: 'Please enter a valid number'
            },
            {
                name: 'pattern',
                message: 'Not a valid number',
                pattern: '[a-zA-Z0-9]{3}\\s[a-zA-Z]{1,2}\\s[0-9]{5}'
            }
        ]
    };
    datePipe: any;
    public JSON = JSON;
    constructor(
        private fb: UntypedFormBuilder,
        private loaderService: LoaderService,
        private sharedService: SharedService,
        private claimService: ClaimsService,
        private oshaService: OshaService
    ) { }

    // ngOnChanges() {
    //     if (this.showRefine) {
    //         this.RefineTheseResultsModalRef.show();
    //     } else if (!this.showRefine) {
    //         this.RefineTheseResultsModalRef.hide();
    //     }
    // }
    claimNumberSelection = AppConfig.claimNumberSelection;
    insuredDriverNameSelection = AppConfig.insuredDriverNameSelection;
    accidentDateSelection = AppConfig.accidentDateSelection;
    totalPaidSelection = AppConfig.totalPaidSelection;
    totalIncurredSelection = AppConfig.totalIncurredSelection;
    cancelResultsBtnConfig = AppConfig.cancelResultsBtnConfig;
    resetBtnConfig = AppConfig.resetBtnConfig;
    refineResultsBtnConfig = AppConfig.refineResultsBtnConfig;
    accidentDateValue = AppConfig.accidentDateValue;
    accidentDateValueSecond = AppConfig.accidentDateValueSecond;
    optionsData: any;
    ngOnInit() {
        if(this.loaderService.getItem('refineFlag')){
        this.loaderService.setItem("validationCheck", 0)
        this.loaderService.removeItem('refineFlag')
        } else {
            this.loaderService.setItem("validationCheck", 1)
        }
        this.refineTheseResultsTitle = REFINE_CLAIM_RESULTS_TITLE;
        this.sharedService.apiResponse$?.subscribe((response) => {
            if (response) {
                this.apiResponse = response;
            }
        });

        this.sharedService.apiData$?.subscribe((data) => {
            if (data) {
                this.apiDataRefine = data;
                this.fields = this.apiDataRefine;
                const columnsDataApi = this.fields.listClaimDetails[0].claims[0].refineResults.columnDetails;
                //this.columns = columnsDataApi.slice(1);
                if (this.context === 'establishment') {
                    this.columns = columnsDataApi.filter((val) => val.displayColumnName !== 'Estab Id')
                } else {
                    this.columns = columnsDataApi?.slice(1);
                }
                this.optionsData = this.fields.listClaimDetails[0].claims[0].refineResults.refineColumnLists;
                this.columns.forEach((field) => {
                    if (field.columnType) {
                        const control = new FormControl('');
                        this.RefindResultForm.addControl('c_' + field.columnId, control);
                        if (field.columnType?.toUpperCase() === 'DATE') {
                            this.claimService.resetDate?.next('dateReset');
                        }
                    }
                });

                this.claimNumberData = this.fields.listClaimDetails[0].claims[0].refineResults.columnDetails[0]
                this.ClaimNumberValue.name = 'c_' + this.claimNumberData.columnId;
                const control = new FormControl('');
                const controlSelect = new FormControl('');
                this.RefindResultForm.addControl('c_' + this.claimNumberData.columnId, control);
                this.RefindResultForm.addControl('select_' + this.claimNumberData.columnId, controlSelect);

                this.clonedForm = JSON.parse(JSON.stringify(this.RefindResultForm.getRawValue()));
            }
        });
    }
    @Input() refineData;

    showModal() {
        if (this.loaderService.getItem("validationCheck")) {
            this.resetModal()
            this.loaderService.removeItem("validationCheck")
        }

        this.apiDataRefine = this.refineData;
        this.fields = this.apiDataRefine;
        const columnsDataApi = this.fields?.listClaimDetails?.[0]?.claims?.[0].refineResults?.columnDetails;
        if (this.context === 'establishment') {
            this.columns = columnsDataApi.filter((val) => val.displayColumnName !== 'Estab Id')
        } else {
            this.columns = columnsDataApi?.slice(1).filter((val) => val.displayColumnName !== 'Claim Id');
        }
        //this.columns = columnsDataApi?.slice(1);

        this.optionsData = this.fields?.listClaimDetails?.[0].claims?.[0]?.refineResults?.refineColumnLists;
        this.columns?.forEach((field) => {
            if (field.columnType) {
                const control = new FormControl('');
                this.RefindResultForm.addControl('c_' + field.columnId, control);
                if (field.columnType?.toUpperCase() === 'DATE') {
                    this.claimService.resetDate?.next('dateReset');
                }
            }
        });

        this.claimNumberData = this.fields?.listClaimDetails?.[0]?.claims?.[0].refineResults?.columnDetails?.[0];
        this.ClaimNumberValue.name = 'c_' + this.claimNumberData?.columnId;
        const control = new FormControl('');
        const controlSelect = new FormControl('');
        this.RefindResultForm.addControl('c_' + this.claimNumberData?.columnId, control);
        this.RefindResultForm.addControl('select_' + this.claimNumberData?.columnId, controlSelect);
        this.claimNumberSelectionTemplate.field = this.claimNumberSelection;
        this.claimNumberSelectionTemplate.field.name = 'select_' + this.claimNumberData?.columnId;

        this.clonedForm = JSON.parse(JSON.stringify(this.RefindResultForm.getRawValue()));

        this.RefindResultForm.patchValue(this.clonedForm);
        Object.keys(this.RefindResultForm.controls).forEach((key) => {
            this.RefindResultForm.get(key).setErrors(null);
        });
        this.RefineTheseResultsModalRef.show();
    }
    clonedForm: any;
    hideModal(modalName: string) {
        if (modalName !== 'modalClose') {
            this.claimService.resetDynamicForm?.next(this.clonedForm);
            this.RefindResultForm?.reset();
            if (this.clonedForm) {
                if (
                    this.clonedForm['select_' + this.claimNumberData?.columnId] == 'IS NULL' ||
                    this.clonedForm['select_' + this.claimNumberData?.columnId] == 'IS NOT NULL'
                ) {
                    this.hideClaimFeild = true;
                } else {
                    this.hideClaimFeild = false;
                }
            }

            this.RefindResultForm.patchValue(this.clonedForm);
            this.loaderService.setItem('RefindResultFormValue', this.RefindResultForm.getRawValue());
            this.RefineTheseResultsModalRef.hide();
        }

        this.hideRefineFunction();
    }

    claimStatusSelected(event: any) {
        this.claimStatusSelectedValue = event.detail.value;
        this.RefineTheseResultsForm.controls['claimStatusSelectedOption'].setValue(event.detail.value);
    }

    locationCodeSelected(event: any) {
        this.locationCodeSelectedValue = event.detail.value;
        this.RefineTheseResultsForm.controls['locationCodeSelectedOption'].setValue(event.detail.value);
    }

    accidentDateSecond(event: any) {
        this.RefineTheseResultsForm.controls['accidentDateValueSecond'] = event.target.value;
    }

    totalPaidValueSecondFunc(event: any) {
        this.RefineTheseResultsForm.controls['totalPaidValueSecond'] = event.target.value;
    }

    totalIncurredValueSecondFunc(event: any) {
        this.RefineTheseResultsForm.controls['totalIncurredValueSecond'] = event.target.value;
    }

    getOshaListData() {
        const payload = this.createOshaPayloadData(this.apiDataRefine);
        payload.refineCriteria = { refinecolumnList: [] };
        this.loaderService.showLoader();
        this.callOshaRefineResult(payload);
    }
    getOshaEstaListData() {
        const payload = this.createOshaEstablishment(this.apiDataRefine);
        payload.refineCriteria = { refinecolumnList: [] };
        this.loaderService.showLoader();
        this.callOshaRefineResult(payload);
    }
    getClaimListData() {
        let payload:any = {
            claimInfo: {
                shortInfo: {
                    valuationDate: this.apiDataRefine.valuationDate
                },
                applicationAccntDtlId: this.loaderService.getItem('appAccountDetailId'), //2557303038
                applctnUsrID: this.loaderService.getItem('applctnUserId'), //2976026560,
                orgnztnId: this.loaderService.getItem('orgId')
            },
            userId: this.loaderService.getItem('userId'),
            claimDetailType: 'CLAIM_LIST',
            actionType: 'RETRIEVE',
            claimAllFiltersCriteria: {
                claimFilterCriteria: {
                    filterId: this.apiDataRefine?.filterid
                }
            }
        };
        if(this.columnList){
            payload.claimInfo.userProvidedFilterColumns = this.columnList
        }
        if (this.context === 'calendar'){
            payload.claimDetailType = 'CLAIM_LIST_REPORT'
        }

        this.claimService.searchClaimDetailByClaimNumber(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                const dataToSend = { onSuccessMessage: true, apiResponse: resp, updatedColumnToSend: [] };
                this.refineButtonEmit.emit(dataToSend);
            },
            error: (error) => {
                this.loaderService.hideLoader();
            }
        });
    }

    resetModal() {
        this.claimService.resetDynamicForm?.next('reset');
        this.RefindResultForm?.reset();
        this.clonedForm = JSON.parse(JSON.stringify(this.RefindResultForm.getRawValue()));
        this.hideClaimFeild = false;
        this.sharedService.triggerResetCurrency();
        this.sharedService.triggerResetNumber();
        this.sharedService.triggerResetString();
        if (this.context === 'osha') {
            this.getOshaListData();
        } else if (this.context === 'establishment') {
            this.getOshaEstaListData()
        }
        else {
            this.getClaimListData();
        }
    }

    hideTotalIncurredField(event: any) {
        this.RefineTheseResultsForm?.controls['totalIncurredValue'].reset();
        if (event.target.value.split(':')[1].trim() == 'Between') {
            this.hideTotalIncurred = false;
        } else {
            this.hideTotalIncurred = true;
        }
    }

    hideTotalPaidField(event: any) {
        this.RefineTheseResultsForm?.controls['totalPaidValue'].reset();
        if (event.target.value.split(':')[1].trim() == 'Between') {
            this.hideTotalPaid = false;
        } else {
            this.hideTotalPaid = true;
        }
    }

    hideAccidentDateField(event: any) {
        if (event.target.value.split(':')[1].trim() == 'Between') {
            this.RefineTheseResultsForm?.controls['accidentDateValue'].reset();
            this.hideAccidentDate = false;
        } else {
            this.hideAccidentDate = true;
            this.RefineTheseResultsForm?.controls['accidentDateValue'].reset();
        }
    }

    dropdownValidationMain(dropdown, input) {
        dropdown.clearValidators();
        dropdown.updateValueAndValidity();
        dropdown.markAsUntouched();
        dropdown.setErrors({ required: false });
        if (input.value) {
            if (!dropdown.value) {
                dropdown.setValidators([Validators.required]);
                dropdown.updateValueAndValidity();
                dropdown.markAsTouched();
                dropdown.setErrors({ required: true });
            }
        }
    }

    getControlNamesWithValues(form: FormGroup): string[] {
        const controlNames: string[] = [];
        Object.keys(form.controls).forEach((controlName) => {
            const control = form.get(controlName) as FormControl;
            if (control && !controlName.includes('s') && control.value) {
                controlNames.push(controlName);
            }
        });
        return controlNames;
    }

    getControlNamesWithValuesWithSelector(form: FormGroup): string[] {
        const controlNames: string[] = [];
        Object.keys(form.controls).forEach((controlName) => {
            const control = form.get(controlName) as FormControl;
            if (
                control &&
                (control.value === 'IS NULL' || control.value === 'IS NOT NULL') &&
                controlName.includes('select_')
            ) {
                controlNames.push(controlName);
            }
        });
        return controlNames;
    }

    isValidSelect(formValues: any, id: string): boolean {
        return formValues[`select_${id}`] === null || formValues[`select_${id}`] === '(Blank)';
    }

    isValidBetween(formValues: any, id: string): boolean {
        return (
            ((formValues[`c_${id}`] && !formValues[`c_${id}_second`]) ||
                (!formValues[`c_${id}`] && formValues[`c_${id}_second`])) &&
            !(!formValues[`c_${id}`] && !formValues[`c_${id}_second`])
        );
    }

    createPayloadData(apiDataRefine: any): any {
        return {
            claimInfo: {
                shortInfo: {
                    valuationDate: apiDataRefine?.valuationDate
                },
                applicationAccntDtlId: this.loaderService.getItem('appAccountDetailId'),
                applctnUsrID: this.loaderService.getItem('applctnUserId'),
                orgnztnId: this.loaderService.getItem('orgId'),
                userProvidedFilterColumns: this.columnList,
                claimIdentifier: this.refineWithKey
            },
            userId: this.loaderService.getItem('userId'),
            claimDetailType: this.type === '' ? 'REFINE_RESULT' : 'REFINE_OCC_RESULT',
            actionType: 'RETRIEVE',
            refineCriteria: {
                refinecolumnList: []
            },
            claimAllFiltersCriteria: {
                claimFilterCriteria: {
                    filterId: apiDataRefine?.filterid
                }
            }
        };
    }

    createOshaEstablishment(apiDataRefine: any) {
        return {
            organizationId: this.loaderService.getItem('orgId'),
            applicationAccntDtlId: this.loaderService.getItem('appAccountDetailId'),
            actionType: "ESTABLISHMENT",
            operation: "REFINE_ESTABLISHMENTS",
            oshaEstablishmentVO: {
                "estabYr": this.fields?.formValues?.manageYear
            },
            refineCriteria: {
                refinecolumnList: []
            }
        }
    }

    createOshaPayloadData(apiDataRefine: any): any {
        return {
            organizationId: this.loaderService.getItem('orgId'),
            applicationAccntDtlId: this.loaderService.getItem('appAccountDetailId'),
            actionType: 'CASE_MANAGEMENT',
            operation: 'REFINE',
            oshaInfos: {
                oshaCaseDetails: {
                    caseType: this.fields?.formValues.selectCaseType
                },
                claimFilterCriteria: {
                    accidentDateFromDate: this.fields?.accidentFromDate ? moment(this.fields?.accidentFromDate).utc().format('YYYY-MM-DD') : '',
                    accidentDateToDate: this.fields?.accidentToDate ? moment(this.fields?.accidentToDate).utc().format('YYYY-MM-DD') : '',
                    accidentDateOperator: this.fields?.formValues?.selectAccidentDateType
                }
            },
            refineCriteria: {
                refinecolumnList: []
            }
        };
    }

    processColumnDetails(columnDetails: any[], controlNames: string[], formValues: any, payloadData: any): void {
        controlNames.forEach((cn) => {
            const colData = columnDetails
                .map((val, index) => ({ ...val, index }))
                .filter((val) => cn.split('_')[1] == val.columnId);
            if (colData && colData.length > 0) {
                const colIndex = colData[0].index;
                if (formValues[cn] !== '') {
                    if (colData[0].columnType === 'LIST') {
                        columnDetails[colIndex].refinementOptions = this.RefindResultForm.controls[cn].value;
                        columnDetails[colIndex].refinementOperation = null;
                    } else {
                        let col_val = this.RefindResultForm.controls[`c_${colData[0].columnId}`]?.value;
                        columnDetails[colIndex].refinementOperation =
                            this.RefindResultForm.controls[`select_${colData[0].columnId}`]?.value;
                        let col_val_sec = this.RefindResultForm.controls[`c_${colData[0].columnId}_second`]?.value;
                        this.funcSonar(colData[0], cn, columnDetails, colIndex, col_val, col_val_sec);
                    }
                    payloadData.refineCriteria.refinecolumnList.push(columnDetails[colIndex]);
                }
            }
        });
    }

    setPayloadData() {
        if (this.context === 'osha') {
            return this.createOshaPayloadData(this.apiDataRefine);
        } else if (this.context === 'establishment') {
            return this.createOshaEstablishment(this.apiDataRefine)
        } else {
            return this.createPayloadData(this.apiDataRefine);
        }
    }

    refineResultButton(): void {
        const formValues = this.RefindResultForm.value;
        let controlNames = this.getControlNamesWithValues(this.RefindResultForm);
        let controlNamesWithSelector = this.getControlNamesWithValuesWithSelector(this.RefindResultForm);
        let validcheck = false;

        controlNames.forEach((ele) => {
            let id = ele.split('_')[1];
            if (Object.keys(formValues).includes(`select_${id}`) && this.isValidSelect(formValues, id)) {
                validcheck = true;
            }
        });

        Object.keys(formValues).forEach((ele) => {
            if (ele.includes('select_') && formValues[ele] === 'BETWEEN') {
                let id = ele.split('_')[1];
                if (this.isValidBetween(formValues, id)) {
                    validcheck = true;
                }
            }
        });

        if (!validcheck) {
            const payloadData = this.setPayloadData();

            const columnDetails = this.fields?.listClaimDetails[0].claims[0].refineResults.columnDetails;
            this.processColumnDetails.call(this, columnDetails, controlNames, formValues, payloadData);
            this.processColumnDetails.call(this, columnDetails, controlNamesWithSelector, formValues, payloadData);

            this.loaderService.showLoader();
            if (this.apiDataRefine?.page === 'advance-search') {
                payloadData.claimDetailType = 'ADVANCED_SEARCH_REFINE';
            }

            if (this.context === 'osha' || this.context === 'establishment') {
                this.callOshaRefineResult(payloadData);
            } else {
                this.callSearchClaimDetailByClaimNumber(payloadData);
            }

            this.RefineTheseResultsModalRef.hide();
        }
    }


    callSearchClaimDetailByClaimNumber(payloadData) {
        
    let refineList = payloadData.refineCriteria.refinecolumnList.filter(val => {
        return ((val.columnType === 'LIST' || val.columnType === "BOOLEAN") && val.refinementOptions?.length) ||
            (val.columnType !== 'LIST' && val.refinementOperation?.length);});

        this.claimService.searchClaimDetailByClaimNumber(payloadData).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                const dataToSend = {
                    onSuccessMessage: true,
                    apiResponse: resp,
                    updatedColumnToSend: refineList
                };
                this.refineButtonEmit.emit(dataToSend);
            },
            error: (error) => {
                console.error(error);
                this.loaderService.hideLoader();
            }
        });
    }

    callOshaRefineResult(payloadData) {
        let refineList = payloadData.refineCriteria.refinecolumnList.filter(val => {
        return ((val.columnType === 'LIST' || val.columnType === "BOOLEAN") && val.refinementOptions?.length) ||
           (val.columnType !== 'LIST' && val.refinementOperation?.length);});
        this.oshaService.refineResults(payloadData).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                const dataToSend = {
                    onSuccessMessage: true,
                    apiResponse: resp,
                    updatedColumnToSend: refineList
                };
                this.refineButtonEmit.emit(dataToSend);
            },
            error: (error) => {
                console.error(error);
                this.loaderService.hideLoader();
            }
        });
    }

    funcSonar(argColData, argCn, argColumnDetails, argColIndex, argCol_val, argCol_val_sec) {
        if (argColData.columnType === 'STRING' || argColData.columnType === 'CLAIM_NUMBER') {
            argColumnDetails[argColIndex].refinementValue = argCol_val;
        }
        if (argColData.columnType === 'NUMBER') {
            argColumnDetails[argColIndex].refineStartAmount = this.RefindResultForm.controls[argCn]?.value;
            argColumnDetails[argColIndex].refineEndAmount = this.RefindResultForm.controls[argCn + '_second']?.value;
            if (this.RefindResultForm.controls[argCn]?.value === "IS NULL" || this.RefindResultForm.controls[argCn]?.value === "IS NOT NULL") {
                argColumnDetails[argColIndex].refineStartAmount = undefined
            }
        }
        if (argColData.columnType === 'CURRENCY') {
            argColumnDetails[argColIndex].refineStartAmount = argCol_val;
            argColumnDetails[argColIndex].refineEndAmount = argCol_val_sec;
        }
        if (argColData.columnType === 'DATE') {
            argColumnDetails[argColIndex].refineFromDate = argCol_val;
            argColumnDetails[argColIndex].refineToDate = argCol_val_sec;
        }
        if (argColData.columnType === 'BOOLEAN' && argCol_val) {
            if (argCol_val.includes("Blank")) {
                argColumnDetails[argColIndex].refinementOptions = [""];
            }
            else {

                argColumnDetails[argColIndex].refinementOptions = [argCol_val];
            }
        }
    }

    claimFieldHideShow(eve) {
        if (
            eve.target.value.split(':')[1]?.trim() == 'IS NULL' ||
            eve.target.value.split(':')[1]?.trim() == 'IS NOT NULL'
        ) {
            this.hideClaimFeild = true;
            this.RefindResultForm.controls?.['c_' + this.claimNumberData?.columnId]?.setValue('');
        } else {
            this.hideClaimFeild = false;
        }
    }
}
